import React, { Component } from 'react'
import { connect } from 'react-redux'
import compose from 'lodash/fp/compose'

import errorBoundary from 'client/shared/decorators/error-boundary'

import UsersList from 'client/bookmate/blocks/users-list'

import { getBookById } from 'client/bookmate/selectors/book-selector'
import { getUsersByIds } from 'client/bookmate/reducers/users-reducer'
import { UserShort } from 'client/shared/types/user'
import { ResourceName, ResourceProps } from 'client/shared/types/resource'
import { State } from 'shared/types/redux'
import { QueryParams } from 'shared/tools/url-helper'

type Props = {
  resourceType: ResourceName
  resource: ResourceProps
  readers: UserShort[]
  query?: QueryParams
  domain?: string
}

class BookReadersIndexBox extends Component<Props> {
  render() {
    const {
      resource: { readers_count },
      readers = [],
      query,
    } = this.props

    return (
      <UsersList
        query={query}
        users={readers}
        usersCount={readers_count}
        message="book.reading_now"
      />
    )
  }
}

const connectWrapper = connect((state: State, { resourceType }) => ({
  readers: getUsersByIds(state, state[resourceType].readers),
  resource: getBookById(state, state[resourceType].uuid),
  query: state.app.storedQuery,
}))

const wrappers = compose(connectWrapper, errorBoundary)

export default wrappers(BookReadersIndexBox)
